module.exports = __webpack_public_path__ + "static/media/carroussel_16.0ab37408.jpg";